import React, { useState } from 'react';

const PRINT_SECTIONS = [
  { key: 'overview',     label: 'Overview',              icon: '📄', alwaysOn: true },
  { key: 'whatToDo',     label: 'What To Do & Not Do',   icon: '📋' },
  { key: 'evidence',     label: 'Evidence Requirements',  icon: '📁' },
  { key: 'money',        label: 'Money',                  icon: '💷' },
  { key: 'compatible',   label: 'Compatible Opportunities', icon: '🔗' },
  { key: 'whoCanApply',  label: 'Who Can Apply',          icon: '✅' },
  { key: 'howToApply',   label: 'How To Apply',           icon: '🚀' },
  { key: 'criteria',     label: 'Application Criteria',   icon: '📊' },
  { key: 'consents',     label: 'Consents & Permissions', icon: '📜' },
  { key: 'contacts',     label: 'Contact Information',    icon: '📞' },
];

const PrintSectionModal = ({ onPrint, onCancel }) => {
  const [selected, setSelected] = useState(
    new Set(PRINT_SECTIONS.map(s => s.key))
  );

  const toggle = (key) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const selectableKeys = PRINT_SECTIONS.filter(s => !s.alwaysOn).map(s => s.key);
  const allSelected = selectableKeys.every(k => selected.has(k));

  const toggleAll = () => {
    setSelected(prev => {
      const next = new Set(prev);
      if (allSelected) {
        selectableKeys.forEach(k => next.delete(k));
      } else {
        selectableKeys.forEach(k => next.add(k));
      }
      return next;
    });
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 flex flex-col"
        style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 pt-6 pb-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900">Print / Export PDF</h3>
          <p className="text-sm text-gray-400 mt-0.5">Select sections to include</p>
        </div>

        {/* Section list */}
        <div className="px-6 py-4 flex flex-col gap-1 max-h-[60vh] overflow-y-auto">
          {PRINT_SECTIONS.map(section => (
            <label
              key={section.key}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer transition-colors ${
                section.alwaysOn
                  ? 'bg-gray-50'
                  : selected.has(section.key)
                    ? 'bg-indigo-50 hover:bg-indigo-100'
                    : 'hover:bg-gray-50'
              }`}
            >
              <input
                type="checkbox"
                checked={selected.has(section.key)}
                disabled={section.alwaysOn}
                onChange={() => toggle(section.key)}
                className="h-4 w-4 rounded border-gray-300 flex-shrink-0"
                style={{ accentColor: '#615DEC' }}
              />
              <span className="text-base flex-shrink-0">{section.icon}</span>
              <span className="text-sm font-medium text-gray-700">{section.label}</span>
              {section.alwaysOn && (
                <span className="ml-auto text-xs text-gray-400">Always included</span>
              )}
            </label>
          ))}
        </div>

        {/* Footer */}
        <div className="px-6 pb-6 pt-4 border-t border-gray-100 flex items-center justify-between">
          <button
            onClick={toggleAll}
            className="text-xs font-medium hover:underline"
            style={{ color: '#615DEC' }}
          >
            {allSelected ? 'Deselect all' : 'Select all'}
          </button>
          <div className="flex gap-2">
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 rounded-lg hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={() => onPrint(selected)}
              className="px-4 py-2 text-sm font-medium text-white rounded-lg transition-all"
              style={{ backgroundColor: '#615DEC' }}
            >
              Print
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintSectionModal;
